module.exports = __webpack_public_path__ + "static/logo_blue-5fd3eef49e0df3b1c419cf9cb3a000b0.jpg";